import axios from 'axios';


export const getTrainingCertificates = (clause: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-certification?where=` + clause
  );
};

export const deleteTrainingCertificates = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-certification/delete`,
    obj,
    { headers }
  );
};
export const addTrainingCertificates = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-certification/create`,
    obj,
    { headers }
  );
};
export const editTrainingCertificates = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-certification/update`,
    obj,
    { headers }
  );
};
